import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Toggle } from './Toggle.vue';

export const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-sm text-xs font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[2px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    defaultVariants: {
      size: 'sm',
      variant: 'default',
    },
    variants: {
      size: {
        default: 'h-9 px-2 min-w-9',
        icon: 'h-8 w-8 p-0 text-center',
        lg: 'h-10 px-2.5 min-w-10 text-sm',
        sm: 'h-8 px-2 min-w-8 text-xs',
        xs: 'h-6 w-6 px-1 text-xs',
      },
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-dashed data-[state=on]:border-solid bg-transparent hover:bg-accent hover:text-accent-foreground',
        primary: 'data-[state=on]:bg-primary data-[state=on]:text-primary-foreground',
        rounded:
          'border border-muted rounded-full px-3 bg-secondary hover:bg-agent/10 data-[state=on]:bg-agent/10 data-[state=on]:border-agent',
      },
    },
  },
);

export type ToggleVariants = VariantProps<typeof toggleVariants>;
